import styled from "styled-components";

export const Seal = styled.span`
	display: inline-flex;
	align-items: center;
	align-self: center;
	gap: 6px;
	font-size: 12px;
	color: ${({ theme }) => theme.neutral.n500};

	img {
		display: block;
		width: auto;
		height: 28px;
	}
`;
